module.exports = "https://cdn.hellotech.com/client-assets/advanced_audio_systems_desktop_fe9317ed08536a1ffcf45eb4ff089f84.webp";